import gql from 'graphql-tag'

export const ADD_USER = gql`
 mutation insert_users($id: uuid!,$mobile: bigint!,$name: String!,$email: String!,$role: uuid!,$password: String!, $plainPassword: String!, $isActive: Boolean!) {
  insert_users(objects: {email: $email, id: $id, mobile: $mobile, name: $name, role: $role, password: $password, plainPassword: $plainPassword, isActive: $isActive}) {
    returning {
      id
 }
}
  }
`
export const ADD_USERCITIES = gql`
 mutation insert_userCities($userId: uuid!,$city: String!) {
  insert_userCities(objects: {userId: $userId, city: $city}) {
    returning {
      userId
 }
}
  }
`

export const UPDATE_USER = gql`
 mutation ($userId: uuid!,$mobile: bigint!,$name: String!,$email: String!,$role: uuid!, $isActive: Boolean!) {
   update_users (where: {id: {_eq: $userId}}, _set: {name: $name, email: $email, mobile: $mobile, role: $role, isActive: $isActive}) {
    returning {
      id
     }
    }
   delete_userCities(where: {userId: {_eq: $userId}}) {
    returning {
      userId
     }
    }
  }
`
